import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import ShippingBoltIcon from 'dibs-vg/dist/react/shipping-bolt';

// components
import { SbSharedPriceTile } from '../SbSharedPriceTile/SbSharedPriceTile';
import { SbRespTilesSwiper } from '../SbRespTilesSwiper/SbRespTilesSwiper';
import { ServerVarsContextConsumer } from '../../global/ServerVarsContext/ServerVarsContext';
import { SbRespTradeOnApprovalPromoTile } from '../SbRespTradeOnApprovalPromo/SbRespTradeOnApprovalPromoTile/SbRespTradeOnApprovalPromoTile';

import styles from './SbRespPriceTiles.scss';

const MAX_DISPLAY_PRICE_TILES = 3;

export const SbRespPriceTilesComponent = props => {
    const { searchBrowse, viewer } = props;
    const displayUriRef = get(searchBrowse, 'displayUriRef');
    const priceTiles = (get(searchBrowse, 'priceTiles') || [])
        .slice(0, MAX_DISPLAY_PRICE_TILES)
        .filter(Boolean);

    if (!priceTiles.length) {
        return null;
    }

    return (
        <ServerVarsContextConsumer>
            {({ isTablet }) => (
                <div className={styles.container}>
                    <SbRespTilesSwiper isTablet={isTablet}>
                        {priceTiles.map((priceTile, i) => {
                            const { displayName, image, url } = priceTile;
                            const indexLabel = i + 1;
                            return (
                                <SbSharedPriceTile
                                    displayName={displayName}
                                    hoverMessage={
                                        <FormattedMessage
                                            id="sb.SbRespPriceTiles.shop"
                                            defaultMessage="shop"
                                        />
                                    }
                                    image={image}
                                    isPriceBucket
                                    key={`priceTile-${displayName}`}
                                    position={indexLabel}
                                    promoLabel={`Trade Price Range ${indexLabel}`}
                                    searchBrowse={searchBrowse}
                                    url={url}
                                />
                            );
                        })}
                        <SbSharedPriceTile
                            dataTn="priceTile-available"
                            displayName={
                                <FormattedMessage
                                    id="sb.SbRespPriceTiles.inStockNow"
                                    defaultMessage="In Stock Now"
                                />
                            }
                            hoverMessage={
                                <FormattedMessage
                                    id="sb.SbRespPriceTiles.shopReadyItems"
                                    defaultMessage="shop ready to ship items"
                                />
                            }
                            IconComponent={ShippingBoltIcon}
                            image="https://a.1stdibscdn.com/assets/trade/sb_price_tile_in_stock.jpg?height=180"
                            position={4}
                            promoLabel="Available Now"
                            searchBrowse={searchBrowse}
                            url={`${displayUriRef}?production-time-frame=available-now`}
                        />
                        <SbRespTradeOnApprovalPromoTile
                            position={5}
                            searchBrowse={searchBrowse}
                            viewer={viewer}
                        />
                    </SbRespTilesSwiper>
                </div>
            )}
        </ServerVarsContextConsumer>
    );
};

SbRespPriceTilesComponent.propTypes = {
    searchBrowse: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
};

export const SbRespPriceTiles = createFragmentContainer(SbRespPriceTilesComponent, {
    searchBrowse: graphql`
        fragment SbRespPriceTiles_searchBrowse on SearchBrowseQueryConnection {
            ...SbSharedPriceTile_searchBrowse
            ...SbRespTradeOnApprovalPromoTile_searchBrowse
            priceTiles(isTrade: $isTrade) {
                displayName
                image
                url
            }
        }
    `,
    viewer: graphql`
        fragment SbRespPriceTiles_viewer on Viewer {
            ...SbRespTradeOnApprovalPromoTile_viewer
        }
    `,
});
